export function groupExtraInputs() {
    return {
        replace: true,
        scope: {
            'group': '=',
        },
        templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/angular-utilities/directives/groupExtraInputs.html',
    };
}
